document.addEventListener("DOMContentLoaded", function () {

  function hasSelectedSize() {
    return !!document.querySelector(".m-product-option__input:checked");
  }

  function showPopup() {
    const popup = document.getElementById("size-popup");
    if (popup) popup.classList.add("active");
  }

  function hidePopup() {
    const popup = document.getElementById("size-popup");
    if (popup) popup.classList.remove("active");
  }

  /* remove default selected size */
  setTimeout(() => {
    document.querySelectorAll(".m-product-option__input").forEach(input => {
      input.checked = false;
    });

    const variantInput = document.querySelector('input[name="id"]');
    if (variantInput) variantInput.value = "";

    setupBuyNowOverlay();
  }, 200);

  /* normal add to cart validation */
  document.addEventListener("click", function (e) {
    const addBtn = e.target.closest('[name="add"]');

    if (addBtn && !hasSelectedSize()) {
      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();
      showPopup();
      return false;
    }
  }, true);

  document.addEventListener("click", function (e) {

  const buyNowBtn = e.target.closest(".sr-headless-checkout");

  if (!buyNowBtn) return;

  const selectedSize = document.querySelector(".m-product-option__input:checked");

  if (!selectedSize) {
    e.preventDefault();
    e.stopPropagation();
    e.stopImmediatePropagation();

    const popup = document.getElementById("size-popup");

    if (popup) {
      popup.classList.add("active");
    }

    return false;
  }

}, true);

function setupBuyNowOverlay() {

  const buyNowContainer = document.querySelector(
    '.shopify-payment-button, .shiprocket-checkout, [class*="shiprocket"], [id*="shiprocket"]'
  );

  if (!buyNowContainer) return;

  buyNowContainer.style.position = "relative";

  let overlay = buyNowContainer.querySelector(".buy-now-overlay");

  if (!overlay) {
    overlay = document.createElement("div");
    overlay.className = "buy-now-overlay";

    overlay.style.position = "absolute";
    overlay.style.inset = "0";
    overlay.style.zIndex = "999";
    overlay.style.cursor = "pointer";
    overlay.style.background = "transparent";

    overlay.addEventListener("click", function (e) {
      if (!hasSelectedSize()) {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        showPopup();
        return false;
      }
    }, true);

    buyNowContainer.appendChild(overlay);
  }

  overlay.style.display = hasSelectedSize() ? "none" : "block";
}

  /* whenever size changes */
  document.querySelectorAll(".m-product-option__input").forEach(input => {
    input.addEventListener("change", function () {
      hidePopup();
      setupBuyNowOverlay();
    });
  });

  /* keep checking because Shopify rebuilds Buy Now button */
  setInterval(setupBuyNowOverlay, 500);

  /* close popup */
  const popup = document.getElementById("size-popup");
  if (popup) {
    popup.addEventListener("click", hidePopup);
  }

});